import axios from "axios";
import {ElMessage} from "element-plus";
import router from "@/router";
//创建axios 实例
const service = axios.create({
    baseURL: "/", // api的base_url
    timeout: 10000 // 请求超时时间
    // transformRequest: data => qs.stringify(data)
});

const err = error => {
    if (error.response) {
        const data = error.response.data;
        // const token = localStorage.getItem("token");
        if (error.response.status === 500) {
            ElMessage({
                message: '服务器内部异常！！！',
                type: 'error',})

        }
        if (error.response.status === 404) {
            ElMessage({
                message: '请求资源未找到！！！',
                type: 'error',})

        }
    }
   // return Promise.reject(error);
};

// 请求拦截
// response interceptor  请求拦截
service.interceptors.request.use(function(config) {

    if(!config.headers['Content-Type']){
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }
    console.log("采用了请求拦截", config, localStorage.getItem("token"));
    // if (localStorage.getItem("token") === null) {
    //     // 写你的逻辑
    //     //此时为空 未登录
    //     config.data = JSON.stringify(config.data);
    //     router.push("/login").catch(() => {});
    //     return config;
    // } else {
    //     config.headers["token"] = "Bearer " + localStorage.getItem("token"); // 请求头携带token  token暂时用h5存储
    //     return config; // 必须要返回 否则会报错
    // }
    config.headers["token"] =localStorage.getItem("token"); // 请求头携带token  token暂时用h5存储

    return config; // 必须要返回 否则会报错
}, err);

// 响应拦截
// 响应拦截器  这里的状态码是后端返回给你的
service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            // 如果是返回的文件
            // if (response.config.responseType === 'blob') {
            //     return response
            // }

            switch (response.data.code){
                case "200":
                    if(response.config.successFun){
                        response.config.successFun(response.data)
                    }
                    break
                case "-50":
                    ElMessage({
                        message: response.data.msg,
                        type: 'error',})
                    router.push("/login").catch(() => {});
                    break
                default:
                    if(response.config.errorFun){
                        response.config.errorFun(response.data)
                    }
                    ElMessage({
                        message: response.data.msg,
                        type: 'error',})

                    break
            }

           // return Promise.resolve(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {
        err(error)
       // return Promise.reject(error.response);
    }
);



// /**
//  * get方法，对应get请求
//  * @param {String} url [请求的url地址]
//  * @param {Object} params [请求时携带的参数]
//  */
// export function get(url, params){
//     return new Promise((resolve, reject) =>{
//         service.get(url, {
//             params: params
//         }).then(res => {
//             resolve(res.data);
//         }).catch(err =>{
//             reject(err.data)
//         })
//     });}
// /**
//  * post方法，对应post请求
//  * @param {String} url [请求的url地址]
//  * @param {Object} params [请求时携带的参数]
//  */
// export function post(url, params) {
//     return new Promise((resolve, reject) => {
//         service.post(url, params)
//             .then(res => {
//                 resolve(res.data);
//             })
//             .catch(err =>{
//                 reject(err.data)
//             })
//     });
// }
export default service; // 暴露出去给统一写请求的用 （在我这里是dq.js)